// extracted by css-extract-rspack-plugin
export default {"label":"Q8lKi","input":"sFH1J"};